import React from 'react';
import { Heading } from '../../../../components';
import { careerIntro, images } from '../../../../constants';
import { FaBriefcase } from 'react-icons/fa';
import './CareerIntro.css';

const CareerIntro = () => {
    return (
        <section className='career-intro'>
            <div className='content'>
                <Heading title={careerIntro.heading} subTitle={careerIntro.sub} sideHeading={true} />
                <p>{careerIntro.description}</p>
                <ul className="career-features">
                    {careerIntro.points.map((point, index) => (
                        <li key={index}>
                            <FaBriefcase className="icon" />
                            <span>{point}</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div className='image'>
                <img src={images.about2} alt='Career-Pic' />
            </div>
        </section>
    );
};

export default CareerIntro;